import React from 'react';

const Career= () => {
    return (
        <section className="career-section hiro-section bg-primary">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <h2 className="section-title wow fadeInLeft">
                        Join Our Growing Network
                        </h2>
                    </div>
                    <div className="col-md-6 wow fadeInRight">
                        <p className="section-text-ct mb-5">
                        At Wala Work, we connect hard-working laborers with employers who need reliable help. Our platform makes it easy for you to find jobs that match your skills and availability. Whether you're looking for temporary gigs or long-term positions, we've got you covered.
                        </p>
                        <button className="hiro-btn-outline">VIEW MORE</button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Career;
